(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nft-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nft-video-hero')) {
    customElements.define('nft-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.poster = this.querySelector('.nft-video-hero__poster');
        if (!this.video) return;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.visible = false;
        this.ready = false;
        this.onPlaying = () => this.classList.add('is-playing');
        this.onError = () => this.classList.remove('is-playing');
        this.syncPlayback = () => {
          if (this.motion.matches || this.connection?.saveData) {
            this.video.pause();
            this.classList.remove('is-playing');
            return;
          }
          if (!this.ready || document.hidden || !this.visible) {
            this.video.pause();
            return;
          }
          if (!this.video.getAttribute('src')) {
            const mobile = window.matchMedia('(max-width: 749px)').matches;
            const source = mobile ? this.video.dataset.mobileSrc : this.video.dataset.desktopSrc;
            if (!source) return;
            this.video.src = source;
          }
          this.video.play().catch(() => {});
        };
        this.start = () => {
          const ready = () => {
            if (!this.isConnected) return;
            this.ready = true;
            this.syncPlayback();
          };
          if ('requestIdleCallback' in window) this.idleId = window.requestIdleCallback(ready, { timeout: 1500 });
          else this.timerId = window.setTimeout(ready, 100);
        };
        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('error', this.onError);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.05 });
        this.observer.observe(this.querySelector('.nft-video-hero__media'));
        this.motion.addEventListener('change', this.syncPlayback);
        this.connection?.addEventListener('change', this.syncPlayback);
        document.addEventListener('visibilitychange', this.syncPlayback);
        if (!this.poster || this.poster.complete) this.start();
        else {
          this.poster.addEventListener('load', this.start, { once: true });
          this.poster.addEventListener('error', this.start, { once: true });
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
        this.video?.removeEventListener('playing', this.onPlaying);
        this.video?.removeEventListener('error', this.onError);
        this.poster?.removeEventListener('load', this.start);
        this.poster?.removeEventListener('error', this.start);
        this.motion?.removeEventListener('change', this.syncPlayback);
        this.connection?.removeEventListener('change', this.syncPlayback);
        document.removeEventListener('visibilitychange', this.syncPlayback);
        if (this.idleId !== undefined) window.cancelIdleCallback(this.idleId);
        window.clearTimeout(this.timerId);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
